export enum BancoOrigemEnum {
  Itau = 0,
  Bradesco = 1,
  Xp = 2
}

export const BancoOrigemEnumNome = new Map<BancoOrigemEnum, string>([
  [BancoOrigemEnum.Itau, 'Itau'],
  [BancoOrigemEnum.Bradesco, 'Bradesco'],
  [BancoOrigemEnum.Xp, 'XP']
]);